import { LitElement, css } from "lit";
import { customElement } from "lit/decorators.js";

import "./pages/app-home";
import "../public/components/header";
import "../public/components/logo";
import "../public/styles/global.css";
import { router } from "./router/router";
import { requestPermission } from "./services/firebase-messaging";

@customElement("app-index")
export class AppIndex extends LitElement {
  static styles = css`
    main {
      padding-left: 16px;
      padding-right: 16px;
      padding-bottom: 16px;
    }
  `;

  firstUpdated() {
    router.addEventListener("route-changed", () => {
      if ("startViewTransition" in document) {
        (document as any).startViewTransition(() => this.requestUpdate());
      } else {
        this.requestUpdate();
      }
    });

    // ✅ Don't spam permission prompts in dev
    if (import.meta.env.PROD) {
      requestPermission();
    }
  }

  render() {
    return router.render();
  }
}
